import { Box, Button, Card, Stack, Typography } from "@mui/material";
import EditBookingModal from "./editBookingModal";
import CompleteBooking from "./completeBooking";
import CancelBooking from "./cancelBooking";
import { convertTo12HourTimeCompact } from "../../../util/general/convertTo12HourTimeCompact";
import timeAgoEST from "../../../util/general/TimeAgoEST";

const PendingEvent = (props) => {
  const toRenderBooking =
    props.pendingBookings.length === 0 ? (
      <>No Pending Bookings</>
    ) : (
      <Stack sx={{ maxWidth: 800 }}>
        {props.pendingBookings.map((e) => (
          <Card
            variant="outlined"
            sx={{
              maxWidth: 400,
              marginTop: "30px",
              borderWidth: "2px",
              padding: "10px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.112)",
              "&:hover": {
                boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.187)",
              },
            }}
            key={e._id}
          >
            <Stack direction="row" justifyContent="space-between">
              <Box>
                <Typography Typography variant="h6" gutterBottom>
                  {e.bookingDetail.party_date.slice(5)}{" "}
                  {convertTo12HourTimeCompact(e.bookingDetail.party_time)}
                </Typography>
                <Typography Typography variant="h6" gutterBottom>
                  {e.bookingDetail.celebrant}
                </Typography>
                <Typography Typography variant="subtitle2" gutterBottom>
                  Party Room: {e.package.package_name}
                </Typography>
                <Typography Typography variant="subtitle2" gutterBottom>
                  Guest: {e.bookingDetail.num_kid}/{e.bookingDetail.num_adult}
                </Typography>
                <Typography Typography variant="subtitle2" gutterBottom>
                  Added {timeAgoEST(e.createdAt)}
                </Typography>
                {/* <Typography Typography variant="subtitle2" gutterBottom>
                  Total: {e.total_cost}
                </Typography>
                <Typography Typography variant="subtitle2" gutterBottom>
                  Non-Refundable Deposite: {e.package.non_refundable_deposite}
                </Typography>
                <Typography Typography variant="subtitle2" gutterBottom>
                  Booking staff: {e.bookingDetail.assigned_employee}
                </Typography> */}
              </Box>
              <Box>
                <CompleteBooking
                  eventData={e}
                  reFreshData={props.reFreshData}
                ></CompleteBooking>

                <EditBookingModal
                  eventData={e}
                  reFreshData={props.reFreshData}
                />

                <CancelBooking eventData={e} reFreshData={props.reFreshData} />
              </Box>
            </Stack>
          </Card>
        ))}
      </Stack>
    );
  return (
    <Stack sx={{ width: "100%", height: "60vh" }}>{toRenderBooking}</Stack>
  );
};

export default PendingEvent;
